// src/pages/DevHub/components/DevTerminalWindow.tsx
// Replaces: .dev-window, .dev-window-header, .dev-window-body

import React from 'react';
import { cn } from '../../../lib/utils';

interface DevTerminalWindowProps {
    /** Left-side title text in the window header bar */
    title: React.ReactNode;
    /** Right-side slot — typically a DevStatusPill or action buttons */
    badge?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
}

const DevTerminalWindow: React.FC<DevTerminalWindowProps> = ({
    title,
    badge,
    children,
    className,
}) => (
    /*
     * .dev-window:
     *   background: #202124;
     *   border-radius: 8px;
     *   overflow: hidden;
     *   display: flex;
     *   flex-direction: column;
     */
    <div className={cn(
        'bg-[#202124] rounded-[8px] overflow-hidden flex flex-col',
        className,
    )}>
        {/*
         * .dev-window-header:
         *   background: #3c4043;
         *   padding: 8px 16px;
         *   display: flex;
         *   justify-content: space-between;
         *   align-items: center;
         *   color: #fff;
         *   font-size: 12px;
         */}
        <div className="bg-[#3c4043] px-[16px] py-[8px] flex justify-between items-center text-white text-[12px]">
            <span>{title}</span>
            {badge && <span>{badge}</span>}
        </div>

        {/*
         * .dev-window-body:
         *   padding: 20px;
         *   min-height: 200px;
         *   overflow: auto;
         */}
        <div className="p-[20px] min-h-[200px] overflow-auto">
            {children}
        </div>
    </div>
);

export default DevTerminalWindow;
